import { Component } from "@angular/core";

@Component({
  selector: "new-ui-auth0-callback",
  templateUrl: "./new-ui-auth0Callback.component.html",
})
export class NewUiAuth0CallbackComponent {}
